import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b94d1f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "history-air-chart" }
const _hoisted_2 = { class: "history-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }, null, -1))
const _hoisted_6 = {
  id: "month-select",
  class: "month"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "year" }, "当年", -1))
const _hoisted_8 = { class: "type" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" PM")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2.5", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" PM")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "10", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" SO")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" NO")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" O")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "3", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { id: "content" }
const _hoisted_25 = { class: "type" }

import {
  ref, onMounted, computed, watch, reactive, onUnmounted,
} from 'vue';
import { Select, } from 'ant-design-vue';
import * as echarts from 'echarts';
import { useStore, } from 'vuex';
import moment, { Moment, } from 'moment';
import {
  factorColorRender,
} from '@/utils';
import { RightCircleFilled, } from '@ant-design/icons-vue';

interface chartOption {
  xAxis: any;
  yAxis: any;
  series: any;
  tooltip: any;
  dataZoom?: any[];
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const { Option, } = Select;

const selectMonth = moment().format('MM');

const selectMonthForDom = moment().format('M月');

const regionName = ref('');

const regionId = computed<number>(() => store.state.OLMap.regionId) || 320100000000;
const location = computed(() => store.state.OLMap.location.location.city);
const pointGid = computed(() => store.state.airStatus.pointGid);
const pointInfo = computed(() => store.state.airStatus.pointInfo);
const selectCityId = computed(() => store.state.airStatus.selectCityId);
const selectRegionName = computed(() => store.state.airStatus.selectRegionName);

// 当前选中气体类型
const activeAqiType = ref('pm25');

// 逐时/逐日
const activeType = ref(0);

// axios请求入参
const params = reactive({
  month: `${moment().format('YYYY')}${selectMonth}`,
  id: regionId.value,
  timeType: 0,
  type: 0,
});

const xAxisData = ref<string[]>([]);
const seriesData = ref<any[]>([]);

/**
 * 加载历史数据
 * @return {void}
 */
const loadAqiByHistory = () => {
  xAxisData.value = [];
  seriesData.value = [];
  store.dispatch('airStatus/loadStatisticalAqiByHistory', params);
};

watch(pointGid, (curid) => {
  params.id = curid;
  params.type = 1;
  loadAqiByHistory();
});

watch(selectCityId, (curid) => {
  params.id = curid;
  params.type = 0;
  loadAqiByHistory();
});

watch(pointInfo, (curInfo) => {
  if (curInfo.pointName) {
    regionName.value = curInfo.pointName;
  }
});

watch(selectRegionName, (curName) => {
  if (curName) {
    regionName.value = curName;
  }
});

watch(regionId, (curRe: any) => {
  params.id = curRe;

  // 获取月每日历史数据
  loadAqiByHistory();
});

/**
 * 一年月数
 * @param {Moment} value  时间
 * @return {any[]} 月份
 */
const getMonths = (value: Moment) => {
  const current = value.clone();
  const localeData = value.localeData();
  const months = [];

  for (let i = Number(moment().format('M')) - 1; i >= Number(moment().subtract(3, 'month').format('M')); i--) {
    current.month(i);
    months.unshift(localeData.monthsShort(current));
  }

  return months;
};

const historyData = computed(() => store.state.airStatus.historyData);

const chartData = ref();

const unit = () => {
  if (activeAqiType.value === 'co') {
    return 'mg/m³';
  }

  return 'μg/m³';
};

// 柱状图配置项
const option: chartOption = reactive({
  xAxis: {
    type: 'category',
    data: [],
    axisLabel: {
      inside: false,
      textStyle: {
        color: '#000',
        fontSize: '16',
        itemSize: '',
      },
    },
    axisTick: {
      show: false,
    },
    axisPointer: {
      show: true,
      type: 'shadow',
      label: {
        show: false,
      },
    },
  },
  yAxis: {
    type: 'value',
    // offset: 100,
    name: `${unit()}`,
    nameTextStyle: {
      fontSize: 16,
      color: '#acacac',
      // align: 'right',
    },

    nameGap: 20,
    axisLabel: {
      inside: false,
      textStyle: {
        color: '#000',
        fontSize: '16',
        itemSize: '',
      },
    },
  },
  series: [
    {
      type: 'bar',
      barMaxWidth: 23,
      data: [],
      // name: activeAqiType.value,
    },
  ],
  tooltip: {
    show: true,
    formatter: (param: any) => `<div style=" ">${param.marker}<span style="font-weight:bold;">${
      param.name
    }</span> ${param.value}${unit()}</div>`,
    textStyle: {
      align: 'left',
      fontSize: '16',
    },
  },
  dataZoom: [
    {
      show: true,
      start: 90,
      end: 100,
    },
  ],
});

const dealOptionData = (data:any, currentProductType: string) => {
  Object.keys(data).forEach((item:any) => {
    if (activeType.value === 0) {
      xAxisData.value.push(moment(item).format('MM/DD'));
    } else {
      const temp = item.split('');

      temp.splice(8,0,'T');
      xAxisData.value.push(moment(temp.join('')).format('MM/DD HH:00'));
    }
    if (currentProductType) {
      seriesData.value.push({
        value: data[item][currentProductType],
        itemStyle: {
          normal: {
            borderRadius: [10,
              10,
              0,
              0,],
            color: factorColorRender(data[item][currentProductType], currentProductType),
          },
        },
      });
    }
  });
  option.xAxis.data = xAxisData.value;
  option.series[0].data = seriesData.value;
  if (activeType.value === 1) {
    option.dataZoom = [
      {
        show: true,
        start: 90,
        end: 100,
      },
    ];
  } else if (activeType.value === 0) {
    if (option.dataZoom) {
      option.dataZoom[0].show = false;
      option.dataZoom[0].start = 0;
      option.dataZoom[0].end = 100;
    }
  }
};

watch(historyData, (cur) => {
  chartData.value = cur;
  dealOptionData(cur, activeAqiType.value);
});

watch(activeAqiType, (cur) => {
  xAxisData.value = [];
  seriesData.value = [];
  dealOptionData(chartData.value, cur);
});

const flag = ref<boolean>(false);

if (option.dataZoom) {
  option.dataZoom[0].show = false;
  option.dataZoom[0].start = 0;
  option.dataZoom[0].end = 100;
}

const chart = ref<any>({});

/**
 *  配置柱状图
 * @param {any} val 配置项
 * @return {void}
 */
const setChart = (val: any) => {
  setTimeout(() => {
    if (val && Object.keys(chart.value).length) {
      chart.value.setOption(val);
    }
  }, 1000);
};

/**
 * 浮层渲染父节点
 * @return {void}
 */
const getPopupContainer = () => document.getElementById('month-select');

/**
 *切换月份
 * @param {number} value 月份
 * @return{void}
 */
const handleMonthChange = (value: string) => {
  params.month = `${moment().format('YYYY')}${value.replace('月', '').padStart(2, '0')}`;
  loadAqiByHistory();
  // setChart(option);
};

/**
 * 一年月数
 * @param {string} value 气体类型
 * @return {any[]} 月份
 */
const handleAqiType = (value: string) => {
  // params.aqiType = value;
  activeAqiType.value = value;
  option.yAxis.name = unit();
  // loadAqiByHistory();

  // setChart(option);
};

/**
 *  逐时/逐日切换
 * @param {any} val value
 * @return {void}
 */
const handleType = (val: number) => {
  activeType.value = val;
  params.timeType = val;
  // activeType.value = val;

  loadAqiByHistory();
  // setChart(option);
};

/**
 * 初始化图表
 * @returns {void}
 */
const initCharts = () => {
  setTimeout(() => {
    const container = document.getElementById('content') as HTMLElement;

    chart.value = echarts.init(container);
    setChart(option);
  });
};

/**
 *  重置图表
 * @param {any} val value
 * @return {void}
 */
const reSize = (): any => {
  if (Object.keys(chart.value).length) {
    chart.value.resize();
  }
};

/**
 * 监听option变化重绘图表
 */
watch(option, (newValue) => {
  setChart(newValue);
});

/**
 * @todo 调用resize方法和拉动滚动轴 报错 Cannot read property 'type' of undefined
 */
onMounted(() => {
  if (regionId.value) {
    loadAqiByHistory();
  }

  /**
   * @todo 监听activeType，改变时重置图表
   */
  /*
   * watch([xAxisData, seriesData,], ([curRe, curPr,], [oldRe, oldSe,]) => {
   *   option.xAxis.data = curRe;
   *   option.series[0].data = curPr;
   * });
   */

  flag.value = true;
  initCharts();
  window.addEventListener('resize', reSize());
});

/**
 * 销毁图表
 */
onUnmounted(() => {
  // window.removeEventListener('resize', reSize());

  echarts.dispose(chart);
  chart.value = {};
  flag.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(regionName.value ? regionName.value : _unref(location)) + "历史空气质量图表 ", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Select), {
            value: _unref(selectMonthForDom),
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectMonthForDom) ? (selectMonthForDom).value = $event : null)),
            dropdownStyle: { textAlign: 'center' },
            getPopupContainer: getPopupContainer,
            onChange: handleMonthChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMonths(_unref(moment)()), (val, index) => {
                return (_openBlock(), _createBlock(_unref(Option), {
                  key: String(index),
                  value: val
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(val), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAqiType('pm25'))),
          class: _normalizeClass(activeAqiType.value === 'pm25' ? 'activeAqiType' : '')
        }, _hoisted_11, 2),
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleAqiType('pm10'))),
          class: _normalizeClass(activeAqiType.value === 'pm10' ? 'activeAqiType' : '')
        }, _hoisted_14, 2),
        _createElementVNode("li", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleAqiType('so2'))),
          class: _normalizeClass(activeAqiType.value === 'so2' ? 'activeAqiType' : '')
        }, _hoisted_17, 2),
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleAqiType('no2'))),
          class: _normalizeClass(activeAqiType.value === 'no2' ? 'activeAqiType' : '')
        }, _hoisted_20, 2),
        _createElementVNode("li", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (handleAqiType('o3'))),
          class: _normalizeClass(activeAqiType.value === 'o3' ? 'activeAqiType' : '')
        }, _hoisted_23, 2),
        _createElementVNode("li", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (handleAqiType('co'))),
          class: _normalizeClass(activeAqiType.value === 'co' ? 'activeAqiType' : '')
        }, " CO ", 2)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_24, null, 512), [
        [_vShow, flag.value]
      ]),
      _createElementVNode("ul", _hoisted_25, [
        _createElementVNode("li", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (handleType(0))),
          class: _normalizeClass(activeType.value === 0 ? 'activeAqiType' : '')
        }, " 逐日 ", 2),
        _createElementVNode("li", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (handleType(1))),
          class: _normalizeClass(activeType.value === 1 ? 'activeAqiType' : '')
        }, " 逐时 ", 2)
      ])
    ])
  ]))
}
}

})